import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';
import { HelpersService } from '@base/shared/services/helpers.service';

@Injectable()
export class ReadersRequests {

  private config = environment;
  private endpointUrl = this.config.baseUrl;

  constructor(
    private http: AppHttpClient,
    private helpers: HelpersService
  ) {
    this.endpointUrl = this.config.mockServerUrl;
  }


  /**
   * Get Readers lists
   */
  list(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.readers}/`;
    return this.http.get(url, payload).toPromise()
  }

  /**
   * Get Reader Detail
   */
  show(readerId, payload?){
    const url = `${this.config.baseUrl}/v2/${this.config.services.readers}/${readerId}/assignments/current`;
    return this.http.get(url, payload).toPromise()

  }


  /**
   * Creare Assignment Reader
   */
  create(readerId, payload?){
    //const url = `${this.config.baseUrl}/v2/${this.config.services.readers}/${readerId}/assignments?key=success`;
    const url = `${this.config.baseUrl}/v2/${this.config.services.readers}/${readerId}/assignments`;
    return this.http.post(url, payload).toPromise()

  }


  /**
   * Path Edit Assignment Reader
   */
  path(readerId, readerAssignmentId, payload?){
    const url = `${this.config.baseUrl}/v2/${this.config.services.readers}/${readerId}/assignments/${readerAssignmentId}`;
    return this.http.patch(url, payload).toPromise()
  }



}
